import React, { useState } from 'react'
import { useMutation } from '@apollo/client';
import { IconFolderPlus } from '@tabler/icons';
import { CREATE_MEDIA_FOLDER } from '../../../graphql/mutation/mediaFolders';
import { MEDIA_FOLDERS } from '../../../graphql/query/mediaFolders';
import Folder from './Folder';

export interface MediaFolderTypes {
  id: number,
  name: string,
  siteId: number,
  createdAt: string,
  updatedAt: string,
}

interface FolderPropsTypes {
  siteId: number,
  setCurrentFolderId: Function,
  currentFolderId?: number,
  children: React.ReactNode,
  standalone?: boolean,
}

const RootFolderIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-folder-cog" width="20" height="24" viewBox="0 0 24 24" stroke-width="1.25" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M12.5 19h-7.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3"></path>
      <path d="M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
      <path d="M19.001 15.5v1.5"></path>
      <path d="M19.001 21v1.5"></path>
      <path d="M22.032 17.25l-1.299 .75"></path>
      <path d="M17.27 20l-1.3 .75"></path>
      <path d="M15.97 17.25l1.3 .75"></path>
      <path d="M20.733 20l1.3 .75"></path>
    </svg>
  )
}

const Folders = ({ siteId, setCurrentFolderId, currentFolderId, children, standalone = false }: FolderPropsTypes) => {
  const [createMediaFolder, { loading, client }] = useMutation(CREATE_MEDIA_FOLDER);

  const createFolder = async () => {
    try {
      const response = await createMediaFolder({
        variables: {
          name: 'New Folder',
          siteId: siteId
        }
      });
      client?.cache?.writeQuery({
        query: MEDIA_FOLDERS,
        variables: {
          siteId: siteId
        },
        data: {
          mediaFolders: [response.data.createMediaFolder]
        }
      });
    } catch (error) {
      console.log(error, 'error----')
    }
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className='mb-3 flex shrink-0 items-center justify-between px-6 pt-6 text-sm'>
        <span className='text-secondary-light'>FOLDERS</span>
        <span className={`text-primary cursor-pointer ${loading && 'pointer-events-none opacity-50'}`} onClick={() => createFolder()} ><IconFolderPlus stroke={1.25} /></span>
      </div>
      <div
        className={
          standalone
            ? 'min-h-0 flex-1 overflow-y-auto px-0'
            : 'h-[225px] overflow-y-auto'
        }
      >
        <div className={`flex items-center py-[8px] px-4 mx-2 rounded cursor-pointer hover:text-primary hover:bg-primary-lighter ${!currentFolderId && 'bg-primary-lighter text-primary'}`} onClick={() => setCurrentFolderId(null)}>
          <RootFolderIcon />
          <span className=' ml-2 mr-auto font-light'>Root</span>
        </div>
        {children}
      </div>
    </div>
  )
}

export default Folders